import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';

import { addViewEvent, EventAttributes } from '@creditornot/browser-telemetry';

type Options = {
  disabled?: boolean;
};

export function usePageView(
  name: string,
  attributes?: EventAttributes,
  { disabled }: Options = {},
) {
  useDeepCompareEffectNoCheck(() => {
    if (disabled) return;
    const viewTimestamp = Date.now();
    return () => {
      const durationMs = Date.now() - viewTimestamp;
      addViewEvent(name, durationMs, attributes);
    };
  }, [name, attributes, disabled]);
}
